import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import api from "../../services/api";

export default function useFlowList({ endpoint, resultKey, companyId }) {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState({ searchParam: "", pageNumber: 1 });
  const [result, setResult] = useState({ records: [], count: 0, hasMore: false });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => setQuery(current => current.searchParam === search.trim() ? current : { searchParam: search.trim(), pageNumber: 1 }), 350);
    return () => clearTimeout(timer);
  }, [search]);
  useEffect(() => {
    let active = true;
    const cancel = axios.CancelToken.source();
    setLoading(true); setError(false);
    setResult({ records: [], count: 0, hasMore: false });
    api.get(endpoint, { params: query, cancelToken: cancel.token, timeout: 20000 }).then(({ data }) => {
      if (!active) return;
      const count = Number(data.count) || 0;
      const lastPage = Math.max(1, Math.ceil(count / 20));
      if (query.pageNumber > lastPage) { setQuery(current => ({ ...current, pageNumber: lastPage })); return; }
      setResult({ records: data[resultKey] || [], count, hasMore: Boolean(data.hasMore) });
    }).catch(err => { if (active && !axios.isCancel(err)) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; cancel.cancel(); };
  }, [endpoint, resultKey, companyId, query, revision]);
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  const setPage = useCallback(pageNumber => setQuery(current => ({ ...current, pageNumber })), []);
  return { ...result, ...query, search, setSearch, setPage, refresh, loading, error };
}
